import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Full from './views/Full'
import Login from './views/Auth/login'
import ForgotPassword from './views/Auth/forgotPassword';
import ResetPassword from './views/Auth/resetPassword';

class App extends React.Component {
  render() {
    return (
        <Switch>
          <Route path="/login" name="login" component={Login} exact/>
          <Route path="/forgot-password" name="forgotPassword" component={ForgotPassword} exact/>
          <Route path="/reset-password/:hash" name="resetPassword" component={ResetPassword}/>
          <Route path="/" name="Full" component={Full}/>
        </Switch>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./client/src/App.js